
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41400)"}},[_c('path',{attrs:{"d":"M14.785 15.627H3.928a1.714 1.714 0 110-3.429h9.714a1.143 1.143 0 001.143-1.143V1.912A1.143 1.143 0 0013.642.77H3.928a1.714 1.714 0 00-1.714 1.668v11.429"}}),_c('path',{attrs:{"d":"M13.643 12.198v3.429","stroke-width":".8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41400"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .152)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    